/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Managed_FailedInputs */



/**
* | output |
* | --- |
* | "Discord refused the last change" |
*
* @param {Leveling_Managed_FailedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_managed_failed = /** @type {((inputs?: Leveling_Managed_FailedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Managed_FailedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Discord отклонил последнее изменение")
	return /** @type {LocalizedString} */ ("Discord refused the last change")
});